import React from 'react'
import Breadcrumb from '../../components/breadcrumb/breadcrumb'
import Hero from '../../components/hero-v2/hero'
import Helmet from 'react-helmet'
import Layout from '../../components/layouts/layout'
import ListItem from '../../components/list-item/list-item'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import s from './index.module.css'
import { withPrefix } from 'gatsby'
import CardSlider from './card-slider'
import { dataListItem } from '../../components/trabajadores-pesqueros/data'

const TrabajadoresPesqueros = () => {
  const titlesBreadcrumb = {
    titleFinal: 'Trabajadores Pesqueros',
  }

  return (
    <Layout>
      <Helmet>
        <title>
          Conoce las condiciones para trabajadores pesqueros | Prima AFP
        </title>
        <meta
          name="title"
          content="Conoce las condiciones para trabajadores pesqueros | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Régimen para trabajadores pesqueros: Desde el 16 de febrero de 2014, según la Ley N° 30003, los registrados en el Ministerio de la Producción pueden afiliarse al SPP, siguiendo condiciones especiales definidas en el reglamento."
          data-react-helmet="true"
        />
        <link
          rel="canonical"
          href="https://www.prima.com.pe/public-zone/trabajadores-pesqueros/"
        />
        <script type="application/ld+json">
          {`
            [
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Inicio",
                    "item": "https://www.prima.com.pe/public-zone/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Trabajadores Pesqueros",
                    "item": "https://www.prima.com.pe/public-zone/trabajadores-pesqueros/"
                  }
                ]
              }
            ]
          `}
        </script>
      </Helmet>
      <Hero
        preTitle={'Soy empleador'}
        title="Trabajadores Pesqueros"
        image={'empresas/trabajadores-pesqueros/banner.svg'}
        imageClassName={'tw-pr-0@lg'}
        imageMobile={'empresas/trabajadores-pesqueros/banner-mobile.svg'}
        className={'bg-orange-4 tw-pr-20 tw-pr-0@lg'}
        arrowDown={true}
      />

      <Breadcrumb
        type="trabajadores pesqueros"
        GTMSection="Soy empleador Trabajadores Pesqueros"
        GTMTitle="Información para trabajadores pesqueros"
        GTMLink="/public-zone/trabajadores-pesqueros/"
        titlesBreadcrumb={titlesBreadcrumb}
      />

      <section className={`bg-white`}>
        <div
          className={`containerWrap tw-pt-12 tw-pb-0 tw-pt-20@lg tw-pb-0@lg`}
        >
          <div className={'tw-px-20@lg tw-mx-8@lg'}>
            <h2
              className={`center font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg tw-mt-0 tw-mb-12`}
            >
              Información para trabajadores pesqueros
            </h2>
            <div className={`flex direction-column direction-row@lg`}>
              <div
                className={`w-100 w-60@lg order-1 order-1@lg tw-pt-0 tw-pt-0@lg`}
              >
                <h3 className="font-family-secondary c-gray--4 fw-6 tw-f-18 tw-mt-0 tw-mb-4 tw-mb-4@lg center left@lg">
                  ¿Desde cuándo aplica el régimen para trabajadores pesqueros?
                </h3>

                <p className="font-family-primary c-gray--4 tw-f-16 center left@lg tw-mb-12 tw-mb-12@lg">
                  A partir del 16 de Febrero de 2014 los trabajadores pesqueros
                  podrán afiliarse al Sistema Privado de Pensiones (SPP) gracias
                  a los lineamientos y condiciones especiales establecidas en la
                  Ley N° 30003 y su reglamento.
                </p>

                <h3 className="font-family-secondary c-gray--4 fw-6 tw-f-18 tw-mt-0 tw-mb-4 tw-mb-4@lg center left@lg">
                  ¿Quiénes son considerados trabajadores pesqueros según esta
                  Ley?
                </h3>

                <p className="font-family-primary c-gray--4 tw-f-16 center left@lg tw-mb-8 tw-mb-8@lg">
                  Se considera trabajador pesquero a aquel inscrito en el
                  registro del Ministerio de la Producción. Cabe mencionar que
                  dichos trabajadores deben estar comprendidos en la Resolución
                  SBS 14707-2010 la cual declaró la disolución y liquidación de
                  la Caja de Beneficios y Seguridad Social del Pescador.
                </p>
              </div>
              <div className={`w-100 w-40@lg order-2 order-2@lg relative`}>
                <img
                  src={withPrefix('/images/woman-mandil.svg')}
                  alt=""
                  className={`${s.imagenBox1} relative db m-auto`}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-turquoise-1 tw-pt-12 tw-pt-12@lg tw-pb-12 tw-pb-12@lg">
        <div className={`containerWrap`}>
          <h2 className="font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg center tw-mt-0 tw-mb-5 tw-mb-6@lg">
            ¿Qué deben hacer los trabajadores pesqueros?
          </h2>

          <div
            className={`center font-family-primary tw-f-16 tw-mt-0 tw-mb-6 tw-px-20@lg tw-mx-8@lg`}
          >
            Dichos trabajadores deberán manifestar por escrito al empleador su
            voluntad de afiliarse al SPP o al Régimen Especial de Seguridad
            Social para los Trabajadores y Pensionistas Pesqueros (REP). Es
            importante señalar que si el trabajador pesquero no manifestó por
            escrito su voluntad de afiliarse a una AFP al armador pesquero,
            dicho armador procederá a afiliarlo al Régimen Especial de Seguridad
            Social para los Trabajadores y Pensionistas Pesqueros (REP).
          </div>

          <h3
            className={`center font-family-secondary fw-7 tw-f-20 tw-f-20@lg tw-mt-0 tw-mb-6`}
          >
            ¿Cuál es el plazo para elegir?
          </h3>
          <CardSlider />
        </div>
      </section>

      <section className={`tw-py-12 bg-white`}>
        <div className={`containerWrap`}>
          <h2 className="font-family-secondary c-turquoise-0 fw-7 tw-f-20 tw-f-24@lg tw-mb-6 tw-mb-6@lg center tw-mt-0">
            Afiliación de los trabajadores pesqueros
          </h2>

          <h3 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mb-6 tw-mb-6@lg center tw-mt-0">
            ¿Cómo afilio a un trabajador pesquero?
          </h3>

          <div className={`tw-pt-10`}>
            <ListItem dataListItem={dataListItem} />
          </div>
        </div>
      </section>

      <section
        className={`tw-pt-12 tw-pt-12@lg tw-pb-20 tw-pb-20@lg bg-orange-4`}
      >
        <div className={'containerWrap'}>
          <h2 className="center tw-mt-0 tw-mb-16 tw-mb-16@lg font-family-secondary c-orange-0 fw-7 tw-f-20 tw-f-24@lg">
            ¿En qué casos no procede la afiliación?
          </h2>
          <div className={`flex@lg`}>
            <div
              className={`flex items-center direction-column justify-start w-100 w-25@lg tw-mb-10 tw-mb-0@lg`}
            >
              <img
                src={withPrefix('/images/contrato.svg')}
                alt=""
                className={`${s.imagenBox2} tw-mb-6 tw-mb-6@lg`}
              />
              <div className="center font-family-secondary fw-6 tw-f-18 tw-f-18@lg tw-px-12 tw-px-4@lg">
                El trabajador no está registrado en el Padrón de Trabajadores
                Pesqueros entregado por PRODUCE.
              </div>
            </div>
            <div
              className={`flex items-center direction-column justify-start w-100 w-25@lg tw-mb-10 tw-mb-0@lg`}
            >
              <img
                src={withPrefix('/images/ico-book-home.svg')}
                alt=""
                className={`${s.imagenBox2} tw-mb-6 tw-mb-6@lg`}
              />
              <div className="center font-family-secondary fw-6 tw-f-18 tw-f-18@lg tw-px-12 tw-px-4@lg">
                El trabajador ya está afiliado al SPP.
              </div>
            </div>
            <div
              className={`flex items-center direction-column justify-start w-100 w-25@lg tw-mb-10 tw-mb-0@lg`}
            >
              <img
                src={withPrefix('/images/ico-cart-blue.svg')}
                alt=""
                className={`${s.imagenBox2} tw-mb-6 tw-mb-6@lg`}
              />
              <div className="center font-family-secondary fw-6 tw-f-18 tw-f-18@lg tw-px-12 tw-px-4@lg">
                El DNI no es válido en RENIEC.
              </div>
            </div>
            <div
              className={`flex items-center direction-column justify-start w-100 w-25@lg tw-mb-0 tw-mb-0@lg`}
            >
              <img
                src={withPrefix('/images/ico-lupa-paper.svg')}
                alt=""
                className={`${s.imagenBox2} tw-mb-6 tw-mb-6@lg`}
              />
              <div className="center font-family-secondary fw-6 tw-f-18 tw-f-18@lg tw-px-12 tw-px-4@lg">
                Los datos informados en la LISTA DE TRABAJADORES no coinciden
                con RENIEC.
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default TrabajadoresPesqueros
